import {addLanguage} from '../../redux/reducers/languageSlice'
import {useDispatch} from 'react-redux'
import {addCohort} from '../../redux/reducers/cohortSlice'
import {addUnit} from '../../redux/reducers/unitSlice'
import {useNavigate} from 'react-router-dom'
import api from '../../../_metronic/helpers/api'
import {showAlert} from '../../redux/reducers/alertSlice'
import {stringify} from 'qs'

function useUtils() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const fetchSchedules = async (text = null, cohortId = null, limit = 10, offset = 0) => {
    const params = {
      limit,
      offset,
      relations: ['cohort'],
      where: {},
    }

    if (text) {
      params.text = text
    }

    if (cohortId && cohortId !== 'Cohort') {
      params.where.cohortId = cohortId
    }

    try {
      const response = await api.get(`/live-stream?${stringify(params)}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message ?? 'Network error',
          variant: 'danger',
        })
      )
    }
  }

  const fetchFullSchedule = async (startDate, endDate, cohortId = null) => {
    const params = {
      relations: ['cohort'],
      startDate,
      endDate,
      where: {},
    }

    if (cohortId && cohortId !== 'Cohort') {
      params.where.cohortId = cohortId
    }

    try {
      const response = await api.get(`/live-stream/date-range?${stringify(params)}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message ?? error?.message,
          variant: 'danger',
        })
      )
    }
  }

  const fetchCohort = async (nextPageToken) => {
    try {
      const params = {
        limit: 100,
        sendToken: true,
        select: {
          id: true,
          title: true,
          createdAt: true,
        },
        order: {
          title: 'ASC',
        },
      }

      if (nextPageToken) {
        params.nextPageToken = nextPageToken
      }

      const response = await api.get(`/cohort?${stringify(params)}`)
      if (response.data.status) {
        return {
          records: response.data.data.records || [],
          nextPageToken: response.data.data.nextPageToken || null,
        }
      }
      return {records: [], nextPageToken: null}
    } catch (error) {
      return {records: [], nextPageToken: null}
    }
  }

  const submitSchedule = async (data) => {
    try {
      const response = await api.post(`/live-stream`, data)
      if (response?.data?.status) {
        dispatch(showAlert({message: 'Successfully added', variant: 'success'}))
        navigate('/schedulelist')
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
    }
  }

  const deleteSchedule = async (id) => {
    try {
      const response = await api.delete(`/live-stream/${id}`)
      if (response?.data?.status) {
        dispatch(showAlert({message: 'Successfully deleted', variant: 'success'}))
        return fetchSchedules()
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
    }
  }

  const handleEdit = async (id) => {
    const params = {
      relations: ['cohort'],
    }

    try {
      const response = await api.get(`/live-stream/${id}?${stringify(params)}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
    }
  }

  const modifySchedule = async (id, data) => {
    try {
      const response = await api.patch(`/live-stream/${id}`, data)
      if (response.data.status) {
        dispatch(
          showAlert({
            message: `Schedule Updated`,
            variant: 'success',
            timeout: '2000',
          })
        )
        navigate('/schedulelist')
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
    }
  }

  const addCSV = async (data) => {
    try {
      const response = await api.post(`/live-stream/add-bulk`, data)
      if (response?.data?.status) {
        return response?.data?.data
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const submitReport = async (data) => {
    try {
      const response = await api.post(`/setting/sendCSVReport`, data)
      return response
    } catch (error) {}
  }

  const fetchAllSchedules = async (text = null, cohortId = null) => {
    const params = {
      returnAllRecords: true,
      offset: 0,
      relations: ['cohort'],
      where: {},
    }

    if (text) {
      params.text = text
    }

    if (cohortId && cohortId !== 'Cohort') {
      params.where.cohortId = cohortId
    }

    try {
      const response = await api.get(`/live-stream?${stringify(params)}`)
      if (response.data.status) {
        const allData = response.data.data.records
        if (allData?.length > 0) {
          return allData?.map((schedule) => ({
            id: schedule?.id,
            topic: schedule?.topic || '',
            cohort: schedule?.cohortId || null,
            totalParticipantsJoined: schedule?.totalParticipantsJoined || 0,
            isForBlackforceMember: schedule?.isForBlackforceMember || false,
            zoomMeetingId: schedule?.zoomMeetingId || '',
            zoomStartLink: schedule?.zoomStartLink || '',
            zoomJoinLink: schedule?.zoomJoinLink || '',
            startTime: schedule?.startTime || '',
            endTime: schedule?.endTime || '',
          }))
        }
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message || 'Something went wrong',
          variant: 'danger',
        })
      )
    }
  }

  return {
    fetchSchedules,
    fetchCohort,
    deleteSchedule,
    submitSchedule,
    handleEdit,
    modifySchedule,
    fetchFullSchedule,
    addCSV,
    submitReport,
    fetchAllSchedules,
  }
}

export default useUtils
